
import { TabsContent } from "@/components/ui/tabs";
import OverviewTab from "./tab-contents/OverviewTab";
import KeywordsTab from "./tab-contents/KeywordsTab";
import PagesTab from "./tab-contents/PagesTab";
import CompetitorsTab from "./tab-contents/CompetitorsTab";
import RecommendationsTab from "./tab-contents/RecommendationsTab";
import { SeoResult } from "./types";
import { useIsMobile } from "@/hooks/use-mobile";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

interface SeoTabContentProps {
  result: SeoResult;
  url: string;
}

export const SeoTabContent = ({ result, url }: SeoTabContentProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className={isMobile ? "overflow-x-auto pb-4" : ""}>
      <Card className="mb-6 bg-gradient-to-r from-desert-sunset/20 to-desert-canyon/20 border-desert-sunset/30">
        <CardContent className="p-4 md:p-6">
          <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
            <div>
              <h3 className="text-lg font-bold text-desert-sunset mb-1">Get Real SEO Data Analysis</h3>
              <p className="text-sm text-muted-foreground">
                This is simulated data for demonstration. For real SEO insights with professional tools like SEMrush, 
                Ahrefs, and AI-powered recommendations, we need to connect you with an expert.
              </p>
            </div>
            <Button asChild className="bg-desert-sunset hover:bg-desert-sunset/90 whitespace-nowrap">
              <Link to="/contact" className="flex items-center">
                Get Real Analysis
                <ExternalLink className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
      
      <TabsContent value="overview" className="space-y-6 min-w-[300px]">
        <OverviewTab result={result} />
      </TabsContent>
      
      <TabsContent value="keywords" className="space-y-4 min-w-[300px]">
        <KeywordsTab result={result} />
      </TabsContent>
      
      <TabsContent value="pages" className="space-y-4 min-w-[300px]">
        <PagesTab result={result} />
      </TabsContent>
      
      <TabsContent value="competitors" className="space-y-4 min-w-[300px]">
        <CompetitorsTab result={result} url={url} />
      </TabsContent>
      
      <TabsContent value="recommendations" className="space-y-4 min-w-[300px]">
        <RecommendationsTab result={result} />
      </TabsContent>
    </div>
  );
};

export default SeoTabContent;
